import { render, staticRenderFns } from "./TodoList.vue?vue&type=template&id=378a2718&scoped=true"
import script from "./TodoList.vue?vue&type=script&lang=ts"
export * from "./TodoList.vue?vue&type=script&lang=ts"
import style0 from "./TodoList.vue?vue&type=style&index=0&id=378a2718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378a2718",
  null
  
)

export default component.exports